import { CapabilityProps } from "./types/power-up"

const PUP_DISPLAY_NAME = "Import Power-Up"
const PUP_ID = "7"

const CAPABILITY_PROPS: CapabilityProps = {
  baseUrl: typeof window !== "undefined" ? window.location.href.replace(/\/$/, "") : "",
  logo: {
    dark: "/static/bd-icon-dark.png",
    light: "/static/logo.png"
  },
  icon: {
    dark: "/static/bd-icon-dark.png",
    light: "/static/logo.png"
  },
  authorizeIcon: {
    dark: "/static/authorize-icon.svg",
    light: "/static/authorize-icon.svg"
  },
  upgradeIcon: {
    dark: "/static/upgrade-icon.svg",
    light: "/static/upgrade-icon.svg"
  }
}

/**
 * The header button the grid adds to its own modal, beside Trello's ✕.
 *
 * Declared here with the modal it belongs to, but registered by the grid
 * itself through `t.updateModal`: an action declared in these options has its
 * callback run in whichever iframe opened the modal, which is not the one
 * holding the grid — and from there `t.popup` has no element to anchor to and
 * `t.modal` would replace the very grid the user is reporting on. Registered
 * from inside, the callback lands in the grid, where it can open a dialog of
 * its own and see what the user is looking at.
 */
const feedbackAction = (onClick: () => void) => ({
  // Absolute, and off the origin rather than off the current href: the iframe's
  // URL carries a signed hash the icon path can't.
  icon: `${typeof window !== "undefined" ? window.location.origin : ""}/static/feedback-icon.svg`,
  alt: "Send feedback",
  position: "right" as const,
  callback: onClick
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getImportModal = (): any => ({
  title: PUP_DISPLAY_NAME,
  url: "./list-action.html",
  fullscreen: true
})

const INITIAL_ROW_COUNT = 30

export {
  PUP_DISPLAY_NAME,
  PUP_ID,
  CAPABILITY_PROPS,
  INITIAL_ROW_COUNT,
  feedbackAction,
  getImportModal
}
